/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Check_InInputs */



/**
* | output |
* | --- |
* | "Check in" |
*
* @param {Players_Check_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_check_in = /** @type {((inputs?: Players_Check_InInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Check_InInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check in")
	return /** @type {LocalizedString} */ ("Check in")
});